import AccordionItem from "../../../../common/AccordionItem";
import MsgDataSourceSummary from "../MsgDataSources/MsgDataSourceSummary";
import MsgDataSourceDetails from "../MsgDataSources/MsgDataSourceDetails";

export default function MsgDataSource({msgSource, mode, label}) {

    return (
        <AccordionItem
            key={msgSource?.id}
            summaryComponent={<MsgDataSourceSummary msgSource={msgSource} label={label}/>}>
            <MsgDataSourceDetails msgSourceProp={msgSource} mode={mode} label={label}/>
        </AccordionItem>
    );
}